var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "16px",
    viewBox: "0 0 35 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tag / New") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "87.6864921%",
    y1: "43.1774847%",
    x2: "10.2264454%",
    y2: "58.8976155%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84818",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F02D11",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tag-/-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L33.6799519,0 C34.2322366,1.45285917e-15 34.6799519,0.44771525 34.6799519,1 C34.6799519,1.09153253 34.6673848,1.1826317 34.6426028,1.27074558 L30.7051028,15.2707456 C30.5838053,15.7020255 30.1904646,16 29.7424519,16 L0,16 L0,16 L0,0 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6740199,4.00004 L20.7900528,8.97281514 L22.7510923,4.00004 L24.4594926,4.00004 L24.7771432,8.99441503 L26.5620758,4.00004 L28.5938872,4.00004 L25.4930913,12 L23.4151959,12 L23.0687428,7.46722266 L21.2253822,12 L19.1466639,12 L18.7187409,4.00004 L20.6740199,4.00004 Z M7.3624873,3.99996 L9.35397513,9.04953475 L10.2666032,3.99996 L12.2292886,3.99996 L10.7776421,11.99992 L8.87832225,11.99992 L6.88107392,6.95034525 L5.96268532,11.99992 L4,11.99992 L5.44670893,3.99996 L7.3624873,3.99996 Z M18.397058,3.99996 L18.1452418,5.48875256 L14.7490144,5.48875256 L14.4601664,7.17594412 L17.3313652,7.17594412 L17.090247,8.61033695 L14.2239858,8.61033695 L13.897283,10.5167274 L17.2885729,10.5167274 L17.0367566,11.99992 L11.8136272,11.99992 L13.1632305,3.99996 L18.397058,3.99996 Z",
    id: "\\uD83C\\uDFA8-Color",
    fill: "#FFFFFF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.b75730e31041eccc574546bef0a04504.svg";
export { ForwardRef as ReactComponent };